<particle-shimmer-loader *ngIf="state === 'loading'" elemCount="1" elemWidth="375" elemHeight="100" elemPadding="10"
                         elemMargin="10" isVisible="true"></particle-shimmer-loader>
<p *ngIf="state === 'error'">The workspace users could not be shown.</p>
<app-empty-content *ngIf="state === 'empty'" title="No users yet." [selectedTab]="selectedTab"></app-empty-content>
<ng-container *ngIf="state === 'ready'">
  <li *ngFor="let user of users">{{user?.fullName}}</li>
</ng-container>
